import { render, staticRenderFns } from "./AthleteEducationCard.vue?vue&type=template&id=0b627d8a&scoped=true&"
import script from "./AthleteEducationCard.vue?vue&type=script&lang=ts&"
export * from "./AthleteEducationCard.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteEducationCard.vue?vue&type=style&index=0&id=0b627d8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b627d8a",
  null
  
)

export default component.exports